<small class="debug">{{ me }}</small>


<div style="padding:20px; margin: 20px; position:relative">
    <app-video-link videoLink="ai_dalle" style="position:absolute; right:15px"></app-video-link>

    <!-- STACK EVERYTHING VERTICALLY -->
    <div fxLayout="column"
         fxLayoutGap="12px"
         fxLayoutAlign="start stretch">

        <!-- 1. media-type selector -->
        <mat-radio-group (change)="onSelection($event)" [(ngModel)]="selectedMediaType"
                         aria-label="AI media type">
            <mat-radio-button value="image" style="margin-right:12px">Image</mat-radio-button>
            <mat-radio-button value="video">Video</mat-radio-button>
        </mat-radio-group>
        <br/>
        <br/>
        <!-- 2. size / resolution selector -->
        <!--        <mat-radio-group [disabled]="selectedMediaType==='video'"-->
        <!--                         (change)="onFilterSelection($event)">-->
        <!--            <mat-radio-button *ngFor="let item of m_numSizeImageType | EnumPipe"-->
        <!--                              [value]="item"-->
        <!--                              [checked]="item[1]===m_enumMediaTypeSelected"-->
        <!--                              style="margin-right:12px">-->
        <!--                {{ item[1] }}-->
        <!--            </mat-radio-button>-->
        <!--        </mat-radio-group>-->

        <br/>
        <br/>
        <!-- 3. prompt -->
        <mat-form-field class="full-width textarea">
            <mat-label>
                {{
                    selectedMediaType === 'image'
                        ? 'enter prompt to generate AI images'
                        : 'enter prompt to generate AI video'
                }}
            </mat-label>
            <textarea matInput rows="3"
                      inputrestriction="basic1"
                      [(ngModel)]="filter"
                      spellcheck="true"></textarea>
            <a matSuffix aria-label="Clear" (click)="clearFilterSelection()">
                <mat-icon>close</mat-icon>
            </a>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <button
                    mat-raised-button
                    color="warn"
                    class="generate-button"
                    [disabled]="loadingImages || filter.length < 5"
                    (click)="getImages()">
                <div class="button-content" *ngIf="!loadingImages">
                    <span>{{ 'general.generateContent' | transloco }}</span>
                </div>
                <div class="button-content loading" *ngIf="loadingImages">
                    <app-loading [size]="'20px'"></app-loading>
                </div>
            </button>
        </div>
        <br/>
        <mat-label style="opacity:.4">
            total {{ callsToday }} / {{ totalCalls }} left today
        </mat-label>
        <br/>
        <br/>
        <div *ngIf="loadingImages">
            <div class="parent-container" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; height: 100%;">
                <ngx-skeleton-loader
                        animation="progress-dark"
                        class="preview-loader"
                        [theme]="{height: '300px', width: '400px', borderRadius: '0', 'background-color': 'var(--background-color1)'}">
                </ngx-skeleton-loader>
                <div flashlightText style="margin-top: 10px; text-align: center; font-weight: bold; font-size: 1.2em;">
                    {{ 'general.severalMinutes' | transloco }}
                </div>
                <div style="margin-top: 10px; text-align: center; font-weight: bold; font-size: 0.9em; opacity: 0.7">
                    {{ 'general.stayPage' | transloco }}
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedMediaType==='video'" class="parent-container" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
        <ng-container *ngIf="videoUploadReady">
            <div style="position: relative; display: inline-block; max-width: 50%; vertical-align: top;">
                <video loop
                       controls
                       autoplay
                       [src]="safeVideoUrl"
                       preload="metadata"
                       style="display: block; width: 100%; height: auto;"></video>
                <a mat-icon-button class="mini-button upload-icon" matTooltip="{{'general.downloadToResources' | transloco}}"
                   (click)="uploadVideoToResource()"
                   style="position: absolute; top: 8px; right: 8px; z-index: 1; background-color: #0066ff; border-radius: 50%;">
                    <mat-icon style="color:white">download</mat-icon>
                </a>
            </div>
        </ng-container>
    </div>

    <div *ngIf="selectedMediaType==='image'" class="parent-container" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
        <ng-container *ngFor="let img of aiImages; trackBy: trackByName">
            <div class="ai-image">
                <ng-container *ngIf="!img.loading">
                    <img [src]="img.base64" loading="lazy">
                    <a mat-icon-button class="mini-button upload-icon"
                       (click)="uploadImageToResource(img)">
                        <mat-icon style="color:white">download</mat-icon>
                    </a>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>
